// @ts-nocheck
import { createSlice, createSelector } from "@reduxjs/toolkit";

const initialState = {
    products: []
}

export const cartSlice = createSlice({
    name: 'cart',
    initialState,
    reducers: {
        addToCart: (state, action) => {
            if (!state.products) state.products = [];
            const existingProductIndex = state.products.findIndex(product => product.id === action.payload.id);

            if (existingProductIndex !== -1) {
                state.products[existingProductIndex].amount += 1;
            } else {
                state.products.push({ ...action.payload, amount: 1 });
            }
        },
        clearCart: (state) => {
            return { products: [] }
        },
        incrementProductAmount: (state, action) => {
            return { products: state.products.map(product => product.id === action.payload.id ? { ...product, amount: product.amount + 1 } : product) }
        },
        decrementProductAmount: (state, action) => {
            const index = state.products.findIndex(product => product.id === action.payload.id);
            if (index !== -1) {
                if (state.products[index].amount > 1) {
                    state.products[index].amount -= 1;
                } else {
                    state.products.splice(index, 1); // Remove the product from the array
                }
            }
        }
    }
})

export const cartProducts = state => state.cart.products || [];

// Selector to calculate total price
export const calculateTotalPrice = createSelector(
    [cartProducts],
    (products) => {
        // Calculate total price from products array
        let totalPrice = 0;
        for (const product of products) {
            totalPrice += product.price * product.amount;
        }
        return totalPrice;
    }
);

export const calculateTotalPriceEuro = createSelector(
    [cartProducts],
    (products) => {
        // Calculate total price from products array
        let totalPrice = 0;
        for (const product of products) {
            totalPrice += product.euroPrice * product.amount;
        }
        return totalPrice;
    }
);

// Selector to calculate total cart count
export const calculateCartCount = createSelector(
    [cartProducts],
    (products) => {
        return products.reduce((total, product) => total + product.amount, 0);
    }
);


export const { addToCart, clearCart, incrementProductAmount, decrementProductAmount } = cartSlice.actions

export default cartSlice.reducer